module.exports = new __parcel__URL__("objective_tweet_button.915770a2.png").toString();